import { MediaMatcher } from '@angular/cdk/layout';
import {
  ChangeDetectorRef,
  Component,
  OnDestroy,
  ViewChild,
  AfterViewInit,
  HostListener, ElementRef
} from '@angular/core';
import { SideNavService } from './side-nav.service';
import { MatSidenav } from '@angular/material/sidenav';
import { AuthService } from '../../shared-modules/services/auth.service';
import {
  Router,
  NavigationEnd,
  NavigationStart,
  NavigationCancel
} from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { MatIconRegistry } from '@angular/material/icon';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { GlobalApiService } from 'src/app/shared-modules/global-api.service';
import { SocketService } from 'src/app/shared-modules/services/chat.service';
import { Event } from '../../models/side-nav.data';
import { NotifierService } from 'angular-notifier';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RestrictPlanService } from '../restrict-plan.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'fyt-side-nav',
  templateUrl: 'side-nav.component.html',
  styleUrls: ['side-nav.component.css'],
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({ transform: 'rotate(0deg)' })),
      state('expanded', style({ transform: 'rotate(180deg)' })),
      transition('expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
      ),
    ])
  ]
})
export class SideNavComponent implements OnDestroy, AfterViewInit {
  @ViewChild('snav', { static: false }) snav: MatSidenav;
  peerConnection!: RTCPeerConnection;
  mobileQuery: MediaQueryList;
  fillerNav: any = [];
  dynamicNav: any = [];
  private _mobileQueryListener: () => void;
  isDynamicNav: boolean;
  iconUrl = '../../../assets/icons/sidenavIcons/';
  expanded: boolean;
  userData: any;
  brandName: any;
  centreName: any;
  defaultSettingModal: boolean;
  isNavLoading: boolean;
  loaderType: string;
  showSearch: any = {};
  searchInput: any;
  userName: any;
  profilePic: any;
  role: any;
  socConStat: any = false;
  minlength: any = 10;
  maxlength: any = 10;
  socket: any;
  userDetails: any;
  sendObj: any = {};
  ioConnection: any;
  popupFlag: boolean = false;
  onAction: any;
  localData: any;
  esslExist: boolean = false;
  restriction: any;
  attendanceArray: any = [];
  connected: boolean = false;
  RETRY_INTERVAL: any = 10000;
  timeout;
  globalNotifyObj: any = {};
  smsExpiryFlag: boolean = false;
  settingsData: any;
  subExpiredPupUp: boolean;
  myInputObj: any = {};
  currentActive: any = 0; // index of currently active sidenav
  brandLogo: any;
  restrictionFlag: boolean = false;
  restrictionObj: any = {};
  settingsRestrictions: any = [];
  openDoorPopupFlag: boolean = false;
  private readonly notifier: NotifierService;
  doorStatus: boolean = false;
  volume: any = "volume";
  openSubscriptionPop: boolean = false;
  contactDrawerFlag: boolean = false;
  ratingPopupFlag: boolean = false;
  @ViewChild('customTemplate', { static: true }) customNotificationTmpl;
  accessList: any = [];
  notification = 0;
  adminPlanName = "";
  planaccessList: any = {};
  dashboardIndex: any;
  isNewDashboard = false;
  showBlink = true;
  showTryMe = true;
  branchId: any;
  DashboardActive: any = false;
  isBlinking = true;
  rmData: any;
  notificationFlag: boolean = false;
  biometricPopupFlag: boolean = false;
  message: any;

  constructor(
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher,
    private sideNavService: SideNavService,
    private authService: AuthService,
    private router: Router,
    public sanitizer: DomSanitizer,
    public socketService: SocketService,
    public globalApiService: GlobalApiService,
    private restrictplanService: RestrictPlanService,

    // public subscription: Subscription,
    private iconRegistry: MatIconRegistry,
    private snackbar: MatSnackBar,
    public notifierService: NotifierService) {
    this.notifier = notifierService;
    this.mobileQuery = media.matchMedia('(max-width: 768px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    let esslAvailabel;
    this.rmData = JSON.parse(localStorage.getItem('userDetails'));
    let eData = JSON.parse(localStorage.getItem('userDetails'));
    if (eData) esslAvailabel = eData.esslSrNo
    if (esslAvailabel) {
      setInterval(() => { this.checkDoorConnetion(); }, 60000); // for check door connection after every 60 seconds
    }
  }

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
    this.checkAccess();
  }

  checkDoorConnetion() {
    let postObj = {};
    this.sideNavService.doorConnection(postObj).subscribe(res => {
      if (res.statusCode == '001') {
        this.doorStatus = true;
      } else {
        this.doorStatus = false;
      }
    })
  }

  ngAfterViewInit() {
    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationStart) {
          this.isNavLoading = true;
        }
        else if (
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel
        ) {
          this.isNavLoading = false;
          this.onSearchCardAction();
        }
      });
  }

  ngOnInit() {
    this.checkAccess()
    this.checkSmsStatus();
    this.settingsRestrictions = localStorage.getItem('settings') ? JSON.parse(localStorage.getItem('settings')) : [];
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    this.isNewDashboard = this.userDetails.setNewDashActive

    this.planaccessList = this.userDetails.planAccess;
    this.adminPlanName = this.userDetails.adminPlanName
    this.refreshData();
    this.myInputObj = {
      'daysRemaining': this.userDetails.daysRemaining,
      'discount': this.userDetails.discount,
      'pendingBalance': this.userDetails.fytPlanPendingBalance,
      'dueDate': this.userDetails.fytPlanDueDate,
      'adminPlanId': this.userDetails.adminPlanId
    }

    const sessionSeenPopup = sessionStorage.getItem('subExpiredPopupSeen');

    // For testing: Comment out the sessionSeenPopup check if you want it to show on every refresh
    if (this.userDetails.showPopup && this.userDetails.daysRemaining > 0 && sessionSeenPopup) {

      this.subExpiredPupUp = false;
    } else {

      this.subExpiredPupUp = this.userDetails.showPopup;
      if (this.subExpiredPupUp && this.userDetails.daysRemaining > 0) {
        sessionStorage.setItem('subExpiredPopupSeen', 'true');
      }
    }
    this.onSocketInit();
    this.emmitFun();
    this.updateEssl();
    this.getSettings();
    this.newUpdateCount()
    // sound setting check
    let soundSett = localStorage.getItem('soundSetting');

    this.volume = soundSett === "false" ? "m_sound_mute.png" : "m_sound.png"
    this.checkRoute(this.router);
    this.isNewDashboard = this.userDetails.setNewDashActive || false;
    this.isBlinking = !this.isNewDashboard;
    this.checkRouteForBlinking();
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.checkRouteForBlinking();
      });

    this.socketService.onScreenShareRequest().subscribe(({ from, room, message }) => {
      this.startScreenShare();
    });

    this.socketService.onAnswer().subscribe(async ({ answer, sender, room }) => {
      try {
        if (this.peerConnection) {
          await this.peerConnection.setRemoteDescription(new RTCSessionDescription(answer));
        }
      } catch (error) {
      }
    });

    this.socketService.onIceCandidate().subscribe(({ candidate, sender, room }) => {
      try {
        if (this.peerConnection && candidate) {
          this.peerConnection.addIceCandidate(new RTCIceCandidate(candidate));
        }
      } catch (error) {
      }
    });
  }

  async startScreenShare() {
    const stream = await navigator.mediaDevices.getDisplayMedia({ video: true });

    // Generate a unique room name for this session
    const roomName = `screen-share-${this.userDetails.defaultSetting.defaultBranchId}-${Date.now()}`;

    this.peerConnection = new RTCPeerConnection({
      iceServers: [
        { urls: 'stun:stun.l.google.com:19302' }
      ]
    });

    stream.getTracks().forEach(track => this.peerConnection.addTrack(track, stream));

    this.peerConnection.onicecandidate = (event) => {
      if (event.candidate) {
        this.socketService.sendIceCandidate('admin-id', this.userDetails.defaultSetting.defaultBranchId, roomName, event.candidate);
      }
    };

    const offer = await this.peerConnection.createOffer();
    await this.peerConnection.setLocalDescription(offer);

    this.socketService.sendOffer('admin-id', this.userDetails.defaultSetting.defaultBranchId, roomName, offer);
  }

  checkRouteForBlinking() {
    const currentUrl = this.router.url;
    this.isBlinking = currentUrl === '/gym/dashboard' && !this.isNewDashboard;
  }

  checkPlanRestic(functionName) {

    if (!this.planaccessList[functionName]) {
      this.restrictplanService.showUpgradeModal();
      return true
    } else return false;
  }
  checkAccess() {
    this.sideNavService.checkAccess({}).subscribe(res => {
      if (res.statusCode == '001') {
        this.accessList = res.data;
        localStorage.setItem("accessList", JSON.stringify(this.accessList));
      }
    });
  }

  checkRoute(navItem) {
    this.openSubscriptionPop = false;
    if ((this.accessList).includes(navItem.url)) this.openSubscriptionPop = true;
  }

  toShowNotification(type, message) {
    this.notifier.show({
      type: type,
      message: message
    });
  }

  // for socket
  onSocketInit() {
    this.socketService.initializeSocketIO();
    this.ioConnection = this.socketService.getMessages().subscribe((message) => { this.getDataForPopup(message); });
    // on connect and disconnetct
    this.socketService.onEvent(Event.CONNECT).subscribe(() => { this.emmitFun(); });
    this.socketService.onEvent(Event.DISCONNECT).subscribe(() => { });
    this.socketService.getNotifications().subscribe((data) => { this.toShowNotification(data.type, data.message) });
    this.socketService.getFeedback().subscribe((data) => { this.showFeedback(data) });
    this.socketService.reLoginWhats().subscribe((data) => { this.reLoginWhats(data) })
    this.socketService.getBiometricSuggestion().subscribe((data) => { this.suggestBiometric(data) })
  }

  suggestBiometric(data) {
    this.message = data;
    this.biometricPopupFlag = true;

  }

  reLoginWhats(data) {
    if (this.router.url.includes('/gym/branches/branch')) {
      return;
    } else if (data.branchId === this.userDetails.defaultSetting.defaultBranchId) {
      // this.snackbar.open('WhatsApp session has been logged out.', '', { duration: 3000 });

      this.notificationFlag = true;
      setTimeout(() => {
        this.notificationFlag = false;
      }, 5000);
    }
  }

  closeNotification() {
    this.notificationFlag = false;
  }

  showFeedback(data) {
    this.ratingPopupFlag = true
  }

  closeFeedback() {
    this.ratingPopupFlag = false
  }

  closeBiometricFunc() {
    this.biometricPopupFlag = false;
  }

  updateEssl() {
    let userDetails = JSON.parse(localStorage.getItem('userDetails'));
    this.localData = JSON.parse(localStorage.getItem('userDetails'));
    this.esslExist = userDetails.esslSrNo ? true : false;
    this.restriction = userDetails.componentAccessRestriction;
  }

  emmitFun() {
    this.socketService.notificationConnection({
      from: this.userDetails.name,
      content: localStorage.getItem('userDetails')
    });
  }

  getDataForPopup(data) {
    let notType = data.isActive ? "active" : "expired";
    if (notType !== 'expired' && data.plans[0].pendingAmount > 0 && new Date(data.plans[0].dueDate) < new Date()) {
      notType = "newPending"
    }
    // let notType2 = data.isActive ? "active" : "newPending";
    this.playAudio(notType);
    this.attendanceArray.push(data);
    this.sendObj = data;
    setTimeout(() => { this.attendanceArray.pop() }, 15000);
  }

  playAudio(type) {
    let soundSett = localStorage.getItem('soundSetting');
    if (soundSett !== "false") {
      let audio = new Audio();
      audio.src = `https://fytrackstorage.s3.ap-south-1.amazonaws.com/sound/${type}.wav`;
      audio.load();
      audio.play();
    }
  }

  //open door
  openDoor() {
    if (!this.doorStatus) {
      this.notifier.show({
        type: 'error',
        message: "Biometric device is disconnected, please check your biometric device's connection."
      });
      this.openDoorPopupFlag = false;
    } else {
      this.openDoorPopupFlag = true;
    }
  }

  openDoorFinal() {
    const postObj = {};
    this.sideNavService.openDoor(postObj).subscribe(res => {
      if (res.statusCode == '001') {
        this.closeOpenDoorpopup();
      }
    });
  }

  closeOpenDoorpopup() {
    this.openDoorPopupFlag = false;
  }

  refreshData() {
    this.getNav();
    this.setDefaultBranch();
  }

  setDefaultBranch() {
    this.userData = this.authService.loadUserData();
    let puData = JSON.parse(this.userData);
    this.brandLogo = puData.logo;
    this.userName = puData.name;
    this.profilePic = puData.profilePic;
    this.role = puData.role;
    let defaultSetting = puData.defaultSetting;
    this.brandName = defaultSetting?.defaultCentreName || "-";
    this.centreName = defaultSetting?.defaultBranchName || "-";
  }

  // to get the side nav from Database
  getNav() {
    this.sideNavService.getsideNav().subscribe(res => {
      this.dynamicNav = [];
      if (res && res.Status == 'Success') {
        if (res.data && res.data.length > 0) {
          this.dynamicNav = res.data;
          // let newDashboardActive = true;
          if (this.isNewDashboard == true) {
            // Update URL for dashboard uniqueName
            this.dynamicNav = this.dynamicNav.map(item => {
              if (item.uniqueName === 'dashboard' && this.isNewDashboard == true) {
                return {
                  ...item,
                  url: '/gym/dashboard/v2'
                };
              }
              return item;
            });
          }
        }
      }
    });
  }

  // get settings data
  getSettings() {
    this.sideNavService.accessSettings({}).subscribe(res => {
      if (res && res.Status == 'Success') {
        this.settingsData = res.data;

        localStorage.setItem("settings", JSON.stringify(this.settingsData));
      }
    });
  }

  checkSmsStatus() {
    this.sideNavService.smsLimitFunction({}).subscribe(res => {
      if (res && res.Status == 'Success') {
        this.globalNotifyObj.message = res.data.message;
        this.globalNotifyObj.secondsToDisplay = res.data.secondsToDisplay;
        this.globalNotifyObj.type = res.data.type;
        this.smsExpiryFlag = true;
      }
    });
  }

  // for nav Icons
  getIconForNav(name, imgUrl) {
    this.iconRegistry.addSvgIcon(name, this.sanitizer.bypassSecurityTrustResourceUrl(this.iconUrl + imgUrl));
    return name;
  }

  // to logOut
  logOutUser() {
    this.authService.logout();
  }

  // to navigate
  navigateTo(navItem, index) {

    this.checkRoute(navItem);
    this.currentActive = index;
    if (navItem.children && navItem.children.length > 0) this.expanded = !this.expanded;
    if (this.mobileQuery.matches) this.snav.close();
  }

  showMyProfile() {
    this.router.navigate(['/gym/profile']);
  }

  soundOnOff() {
    let soundSett = localStorage.getItem('soundSetting');
    let keyToStore = (soundSett === "false") ? "true" : "false";
    this.volume = keyToStore === "false" ? "m_sound_mute.png" : "m_sound.png";
    localStorage.setItem('soundSetting', keyToStore);
  }

  supportTo() {
    localStorage.setItem('back_url', this.router.url);
    this.router.navigate(['/gym/support']);
  }

  // to open the details
  onModalAction(event) {
    this.defaultSettingModal = true;
  }

  onCardAction(event) {
    this.defaultSettingModal = false;
    this.restrictionFlag = false;
    if (event.page === 'defaultSettings') {
      this.refreshData();
    }
  }

  openGlobeSearchBox(event?: any) {

    if (this.checkPlanRestic('gobalSearch')) return
    if (!event) return;
    this.showSearch.isOpen = true;
    this.showSearch.boxClass = 'slideInDown';
  }

  onSearchCardAction(event?: any) {
    this.showSearch.boxClass = 'slideOutUp';
    setTimeout(() => {
      this.showSearch.isOpen = false;
      this.searchInput = '';
    }, 1000);
  }

  onNotifyCardAction(event?: any) {
    this.smsExpiryFlag = false;
    this.attendanceArray.pop();
  }

  // for key escape event binding
  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    this.onSearchCardAction();
  }


  dynamicLength(searchInput1) {
    if (isNaN(this.searchInput)) {
      this.minlength = 1;
      this.maxlength = 25;
    } else {
      this.minlength = 10;
      this.maxlength = 10;
    }
  }

  onCancelCard(event) {
    if (event.flag == true) {
      this.refreshData();
    }
    this.subExpiredPupUp = false;
  }

  restrict() {
    this.restrictionFlag = true;
  }

  goToSettings() {
    let localDetails = JSON.parse(localStorage.getItem("userDetails"));
    let branchDetails = localDetails.defaultSetting;
    this.router.navigate([`/gym/branches/branch/${branchDetails.defaultBranchId}/settingFlag`]);
  }

  goToNotification() {
    this.router.navigate(['/gym/communication/notifications']);
  }

  goToNewTab() {
    let currentUrl = window.location.href.split("#");
    window.open(`/#${currentUrl[1]}`);
  }

  openContactView() {
    this.contactDrawerFlag = this.contactDrawerFlag ? false : true;
  }

  newUpdates() {
    if (this.router.navigate(['/gym/support'])) localStorage.setItem('accountsTabIndex', '2');
  }

  newUpdateCount() {
    this.sideNavService.getUpdates().subscribe(res => {
      if (res && res.Status == 'Success') {
        this.notification = res.data.count ? res.data.count : 0
      }
    });
  }

  toggleDashboard() {
    this.isNewDashboard = !this.isNewDashboard;
    this.checkRouteForBlinking();
    this.newDashboardActive();
  }


  newDashboardActive() {
    let postObj = {
      branchId: this.userDetails.defaultSetting.defaultBranchId,
      newDashboardActive: this.isNewDashboard
    };
    this.sideNavService.newDashboardActive(postObj).subscribe(res => {
      if (res.statusCode == '001') {
        this.userDetails.setNewDashActive = this.isNewDashboard
        localStorage.setItem('userDetails', JSON.stringify(this.userDetails))
        this.getNav();
        const route = this.isNewDashboard ? 'gym/dashboard/v2' : 'gym/dashboard';
        this.router.navigate([route]);
      } else {
      }
    })
  }
}
